import { Component } from '@angular/core';
/**
 * Loading state for the application
 */
@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

}
